import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import $ from "jquery";
import {
  // FacebookShareButton,
  TwitterShareButton,
  // PinterestShareButton,
} from 'react-share';
import {FormattedMessage} from "react-intl";
import takeRight from "lodash/takeRight";

import ActionTypes from "../../misc/actionTypes";
import Analytics from './../../analytics';
import UserLoginButton from './../ui/userLoginButton';
import {shareImageRebath, shareImage} from "../bvComponent/core/assets";
import SaveButton from "./saveButton";
import {toggleUserPopup} from "../../actions/actionFunctions";
import Config from "../../config";

export class ShareButton extends Component {

  static propTypes = {
    renderList: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      shareListOpened: false,
    };
    this.clickShareAfterLogin = null;
    this.elements = {
      email: React.createRef(),
      facebook: React.createRef(),
      twitter: React.createRef(),
      pinterest: React.createRef(),
    }
  }

  componentDidMount() {
    $(document).on(ActionTypes.USER_IS_LOGGED_IN, async () => { // click on current active item after unlock
      if (this.clickShareAfterLogin) {
        console.log('this.clickShareAfterLogin', this.clickShareAfterLogin);
        const shareButton = this.elements[this.clickShareAfterLogin];
        if (shareButton) {
          shareButton.current.click();
        }
        this.clickShareAfterLogin = null;
      }
    });
    $(window).on(ActionTypes.USER_POPUP_CLOSED, () => { // reset saved
      if (this.clickShareAfterLogin) {
        this.clickShareAfterLogin = null;
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visualizerTutorialStep === 3 && this.props.visualizerTutorialStep === 2) {
      this.toggleShareList();
    }
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.USER_IS_LOGGED_IN);
    $(window).off(ActionTypes.USER_POPUP_CLOSED);
  }

  renderImage = () => {
    // const canvas = document.getElementById(this.props.canvasId);
    // const imageUrl = canvas.toDataURL();
    const imageUrl = this.props.fabricatorData.isRebath
      ? encodeURIComponent(shareImageRebath)
      : encodeURIComponent(shareImage[document.kvConfig.visualizerType]);
    Analytics.sendClickEvent('share-button-pinterest');
    window.open(`//pinterest.com/pin/create/button/?url=${encodeURIComponent(this.props.shareUrl)}&media=${imageUrl}`, '_blank')
  };

  handleWrapperBlur = (e) => {
    if (!e.target.closest('.share-list__item .mobilebutton') && !e.target.closest('.share') && !this.clickShareAfterLogin) {
      this.toggleShareList();
    }
  };

  toggleShareList = () => {
    Analytics.sendClickEvent(this.state.shareListOpened ? 'share-list-toggle-closed' : 'share-list-toggle-opened');
    this.setState({
      shareListOpened: !this.state.shareListOpened
    }, () => {
      if (this.state.shareListOpened) {
        document.addEventListener('click', this.handleWrapperBlur);
      } else {
        document.removeEventListener('click', this.handleWrapperBlur);
      }
    })
  };

  checkForLoggedIn = (e) => {
    Analytics.sendClickEvent('share-button-' + e.target.dataset.share);
    if (!UserLoginButton.handleLoginClick({...this.props})) {
      e.stopPropagation();
      e.preventDefault();
      this.clickShareAfterLogin = e.target.closest(this.props.renderList ? ".menu-dropdown__list-item" : ".mobilebutton").dataset.share;
      return false;
    }
    return true;
  };

  faceBookButtonClick = (event) => {
    if (this.checkForLoggedIn(event)) {
      // const fbUrl = (Config.isMobile() || isMobile)
      //   ? "https://m.facebook.com/sharer/sharer.php?u="
      //   : "https://www.facebook.com/sharer/sharer.php?&p[url]=";
      const fbUrl = "https://facebook.com/sharer/sharer.php?u=";
      const qfUrl = location.protocol + "//" + takeRight(window.location.hostname.split('.'), 2).join('.') + "/url?u=";
      const shareUrlSplitted = this.props.shareUrl.split(".com")
      if (Config.isDevMode()) {
        console.log("this.props.shareUrl", this.props.shareUrl);
        console.log("shareUrlSplitted", shareUrlSplitted);
      }
      window.open(
        fbUrl + qfUrl + shareUrlSplitted[0] + ".com" + encodeURIComponent(shareUrlSplitted[1]),
        'facebook-share-dialog',
        'width=630,height=420'
      );

      // 'https://www.facebook.com/dialog/share?\n' +
      // '  app_id=402959133605207&display=page&href='+this.props.shareUrl +
      // '  app_id=402959133605207&display=page&href=https%3A%2F%2Ffacebook.com%2Fdocs%2F&redirect_uri=https%3A%2F%2Fdevelopers.facebook.com%2Ftools%2Fexplorer',

      return false;
    }
  };

  getShareButtons = () => {
    const dashboardFramed = Config.isVisualizerManagement();
    const allPagesEnabled = !document.kvConfig.visualizerOnly;
    return (
      <ul className="share-list">
        <li className="share-list__item">
          <a className="mobilebutton mobilebutton--email"
             ref={this.elements.email}
             data-share="email"
             href={`mailto:?subject=Check out My ${document.kvConfig.visualizerType} Visualizer design&body=${encodeURIComponent(this.props.shareUrl)}`}
             onClick={this.checkForLoggedIn}>
            <span className="mobilebutton-text">email</span>
          </a>
        </li>
        <li className="share-list__item">
          <button className="mobilebutton mobilebutton--facebook"
                  ref={this.elements.facebook}
                  data-share="facebook"
                  onClick={this.faceBookButtonClick}>
            <span className="mobilebutton-text">facebook</span>
          </button>
          {/*<FacebookShareButton url={this.props.shareUrl}>*/}
          {/*<button className="mobilebutton mobilebutton--facebook"*/}
          {/*data-share="facebook"*/}
          {/*onClick={this.checkForLoggedIn}>*/}
          {/*<span className="mobilebutton-text">facebook</span>*/}
          {/*</button>*/}
          {/*</FacebookShareButton>*/}
        </li>
        <li className="share-list__item">
          <button className="mobilebutton mobilebutton--pinterest"
                  data-share="pinterest"
                  ref={this.elements.pinterest}
                  onClick={this.props.isPhoneNumberValidated ? this.renderImage : this.checkForLoggedIn}>
            <span className="mobilebutton-text">pinterest</span>
          </button>
        </li>
        <li className="share-list__item">
          <TwitterShareButton url={this.props.shareUrl} title={`Click Here to Design your Dream ${document.kvConfig.visualizerType}!`}>
            <button className="mobilebutton mobilebutton--twitter"
                    data-share="twitter"
                    ref={this.elements.twitter}
                    onClick={this.checkForLoggedIn}>
              <span className="mobilebutton-text">twitter</span>
            </button>
          </TwitterShareButton>
        </li>
        {!this.props.isMobile || dashboardFramed
        || (this.props.fabricatorData.checkout && this.props.goToCart && allPagesEnabled) ? null : (
          <li className="share-list__item">
            <SaveButton/>
          </li>
        )}
        {/*<li className="share-list__item">*/}
        {/*<button className="mobilebutton mobilebutton--houzz">*/}
        {/*<span className="mobilebutton-text">houzz</span>*/}
        {/*</button>*/}
        {/*</li>*/}
      </ul>
    )
  };

  getShareList = () => {
    return (
      <ul className="menu-dropdown__list">
        <li className="menu-dropdown__list-item menu-dropdown__list-item--email" data-share="email">
          <a href={`mailto:?subject=Check out My ${document.kvConfig.visualizerType} Visualizer design&body=${encodeURIComponent(this.props.shareUrl)}`}
             onClick={this.checkForLoggedIn}
             ref={this.elements.email}
             title="Share by Email">Email</a>
        </li>
        <li className="menu-dropdown__list-item menu-dropdown__list-item--facebook"
            data-share="facebook"
            ref={this.elements.facebook}
            onClick={this.faceBookButtonClick}>
          facebook
        </li>
        <li className="menu-dropdown__list-item menu-dropdown__list-item--pinterest"
            data-share="pinterest"
            ref={this.elements.pinterest}
            onClick={this.props.isPhoneNumberValidated ? this.renderImage : this.checkForLoggedIn}>
          pinterest
        </li>
        <TwitterShareButton url={this.props.shareUrl} title={`Click Here to Design your Dream ${document.kvConfig.visualizerType}!`}>
          <li className="menu-dropdown__list-item menu-dropdown__list-item--twitter"
              data-share="twitter"
              ref={this.elements.twitter}
              onClick={this.checkForLoggedIn}>
            Twitter
          </li>
        </TwitterShareButton>
        {/*<li className="menu-dropdown__list-item menu-dropdown__list-item--houzz">*/}
        {/*<a target="_blank" data-url={this.props.shareUrl} data-hzid="51503"*/}
        {/*data-locale="en-US"*/}
        {/*data-img="http://demo.quotesflooring.com/content/Views/quickquote-v3-bv/images/icons/Icon-Ring-Desktop.svg"*/}
        {/*data-title="QuickQuote Visualizer" data-desc="QuickQuote Visualizer" data-category="Baby and Kids" data-showcount="1"*/}
        {/*href="https://www.houzz.com">Houzz</a></li>*/}
      </ul>
    )
  };

  render() {
    return (
      <div className={"share" + (this.state.shareListOpened ? " share--opened" : "")}>
        <button className={"mobilebutton mobilebutton--share"
        + (this.state.shareListOpened ? " mobilebutton--share--active" : "")} onClick={this.toggleShareList}>
          <span className="mobilebutton-text"><FormattedMessage id="header.shareButton"/></span>
        </button>
        {this.props.renderList ? this.getShareList() : this.getShareButtons()}
      </div>
    )
  }

}
const mapStateToProps = (store) => {
  const {isMobile, shareUrl} = store.serverState;
  return {
    isMobile,
    shareUrl,
    fabricatorData: store.fabricatorState,
    visualizerTutorialStep: store.tutorialState.visualizerTutorialStep,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    userIsLoggedIn: store.userState.userIsLoggedIn,
  }
};
export default connect(mapStateToProps, {
  toggleUserPopup
})(ShareButton);
